import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Center from '@zenbusiness/zui/Center';
import Grid from '@zenbusiness/zui/Grid';
import Link from '@zenbusiness/zui/Link';
import PageContainer from '@zenbusiness/zui/PageContainer';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './AccountNotFoundMobile.styles';

const contactUsUrl = 'tel:844-493-6249';

const MobileAccountNotFound = () => (
  <PageContainer>
    <Center p={2}>
      <Styled.GridContainer>
        <Grid item>
          <Styled.ContentHeader title="We can&apos;t find this account" subtitle="We couldn&apos;t sign you in with the info you provided. Let&apos;s get you back on track." />
        </Grid>
        <Grid item>
          <Card sx={{ marginBottom: 1.5 }}>
            <CardContent>
              <Styled.SectionHeading>
                Are you new here?
              </Styled.SectionHeading>
              Welcome! You need to create an account first. Get started at www.zenbusiness.com.
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Styled.SectionHeading>
                Already have an account?
              </Styled.SectionHeading>
              <Styled.ListWithLessPadding>
                <li>
                  If you created a
                  {' '}
                  <b>password</b>
                  , you&apos;ll need to enter your account email and
                  password.
                </li>
              </Styled.ListWithLessPadding>
              <Styled.ListWithLessPadding>
                <li>
                  If you authorized
                  {' '}
                  <b>Sign In with Google</b>
                  {' '}
                  or
                  {' '}
                  <b>Sign in with Apple</b>
                  , confirm
                  the account connected to ZenBusiness and try again.
                </li>
              </Styled.ListWithLessPadding>
              <Text align="center" marginTop="4px">Close this window to return to the login screen.</Text>
            </CardContent>
          </Card>
        </Grid>
        <Grid item>
          <Text
            align="center"
            marginBottom="16px"
            size="xs"
          >
            Not sure?
            {' '}
            <Link
              clickstreamProps={{
                elementName: 'account_not_found',
                elementText: 'Contact Us',
                linkDestination: contactUsUrl
              }}
              href={contactUsUrl}
              weight="medium"
              underline="none"
            >
              Contact Us
            </Link>
            {' '}
            for help.
          </Text>
        </Grid>
      </Styled.GridContainer>
    </Center>
  </PageContainer>
);

export default MobileAccountNotFound;
